import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { IncentivesRoutingModule } from './incentives.routing.module';
import { SharedModule } from '../shared/shared.module';
import { ThirdPartyModule } from '../third-party/third-party.module';
import { IncentivesCompensafeComponent } from './components/incentives-compensafe/incentives-compensafe.component';
import { IncentivesInsightsComponent } from './components/incentives-insights/incentives-insights.component';
import { IncentivesReportsComponent } from './components/incentives-reports/incentives-reports.component';
import { IncentivesTransitionComponent } from './components/incentives-transition/incentives-transition.component';
import { IncentivesUpgradeComponent } from './components/incentives-upgrade/incentives-upgrade.component';
import { IncentivesInsightOptionComponent } from './components/incentives-insight-option/incentives-insight-option.component';
import { VolumeEstimatorComponent } from './components/volume-estimator/volume-estimator.component';
import { IncentivesInsightProfitabilityComponent } from './components/incentives-insight-profitability/incentives-insight-profitability.component';
import { IncentivesInsightsRevenueTrendsComponent } from './components/incentives-insights-revenue-trends/incentives-insights-revenue-trends.component';
import { FinancialsAtAGlanceComponent } from './components/financials-at-a-glance/financials-at-a-glance.component';
import { IncentivesComponent } from './components/financials-insight-incentives/financials-insight-incentives.component';
import { FinancialsInsightCompSnapshotComponent } from './financials-insight-comp-snapshot/financials-insight-comp-snapshot.component';
import { GridComponent, GridModule } from '@progress/kendo-angular-grid';
import { CompSnapshotService } from './services/comp-snapshot.service';
import { IncentivesService } from './services/incentives.service';
import { ProfitabilityService } from './services/profitability.service';
import { RevenueService } from './services/revenue.service';
import { VolumeEstimatorService } from './services/volume-estimator-service';

@NgModule({
    declarations: [
        IncentivesComponent,
        IncentivesCompensafeComponent,
        IncentivesInsightsComponent,
        IncentivesReportsComponent,
        IncentivesTransitionComponent,
        IncentivesUpgradeComponent,
        IncentivesInsightOptionComponent,
        IncentivesInsightProfitabilityComponent,
        VolumeEstimatorComponent,
        IncentivesInsightsRevenueTrendsComponent,
        FinancialsAtAGlanceComponent,
        FinancialsInsightCompSnapshotComponent,
    ],
    imports: [CommonModule, IncentivesRoutingModule, SharedModule, GridModule, ThirdPartyModule],
    providers: [
        CurrencyPipe,
        DecimalPipe,
        CompSnapshotService,
        IncentivesService,
        ProfitabilityService,
        RevenueService,
        VolumeEstimatorService,
    ],
    schemas: [NO_ERRORS_SCHEMA],
})
export class IncentivesModule {}
